import React from 'react';
import { LucideIcon } from 'lucide-react';
import { cn } from '../../../../lib/utils';

interface MetricCardProps {
  label: string;
  value: string | number;
  icon: LucideIcon;
  iconColor?: string;
  className?: string;
}

export const MetricCard: React.FC<MetricCardProps> = ({
  label,
  value,
  icon: Icon,
  iconColor = 'text-blue-500',
  className
}) => {
  return (
    <div className={cn('bg-white border border-gray-200 rounded-lg p-4', className)}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="text-sm text-gray-600 mb-1">{label}</div>
          <div className="text-xl">{value}</div>
        </div>
        <Icon className={cn('w-8 h-8', iconColor)} />
      </div>
    </div>
  );
};
